import classNames from "classnames";
import React from "react";

import CSSModules from "lib/utils/css-modules";
import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import styles from "./OrderBillItem.less";
import "./form.css";

@CSSModules(styles)
export default class OrderBillItem extends React.PureComponent {
  render() {
    const {
      name,
      itemQuantity,
      itemQuantityEditable = false,
      itemQuantityMin,
      itemQuantityMax,
      itemName,
      itemNameEditable = false,
      itemUnitPrice,
      itemUnitPriceLabel,
      itemUnitPriceEditable = false,
      itemTotalPrice,
      children,
      controlType,
      error,
      valid = !error,
      onFocus,
      onBlur,
      onChange,
      onRemove,
      summary = false,
      defaultCurrency,
    } = this.props;

    if (itemUnitPriceEditable && !defaultCurrency) {
      throw new Error("parameter defaultCurrency is required");
    }

    if (children && controlType) {
      throw new Error("You can either define children or controlType prop");
    }

    if (controlType && ["number"].indexOf(controlType) === -1) {
      throw new Error(`Unknown controlType: ${controlType}`);
    }

    return (
      <div
        styleName={summary ? "item--summary" : "item"}
        className={classNames("ui field", {
          error: !valid,
        })}
      >
        <div styleName="item-title">
          {itemQuantity !== undefined && (
            <div styleName="item-quantity">
              {itemQuantityEditable ? (
                <FormControl.Input
                  type="number"
                  value={itemQuantity}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onChange={onChange && ((v) => onChange("quantity", v || 0))}
                  min={itemQuantityMin}
                  max={itemQuantityMax}
                />
              ) : (
                itemQuantity
              )}
            </div>
          )}

          <div styleName="item-name">
            {itemNameEditable ? (
              <FormControl.Input
                placeholder={I18n.t("papp.orders.NewOrderItemsForm.add_new_order_item")}
                value={itemName || null}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange && ((v) => onChange("name", v))}
              />
            ) : (
              <label htmlFor={name}>{itemName}</label>
            )}
          </div>

          {onRemove && <FormControl.DeleteRowButton onClick={onRemove} />}
        </div>

        <div styleName="item-prices">
          {!!error && (
            <div styleName="item-help" className="ui help error">
              {error} <i className="icon material-icons">error_outline</i>
            </div>
          )}

          {itemQuantityEditable && controlType === "number" && (
            <div styleName="item-control">
              <FormControl.NumberSwitch
                value={itemQuantity}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange && ((v) => onChange("quantity", v))}
                showCounter={false}
                min={itemQuantityMin}
                max={itemQuantityMax}
              />
            </div>
          )}

          {children && <div styleName="item-control">{children}</div>}

          <div styleName="item-unitPrice" hidden={!itemUnitPrice}>
            {itemUnitPrice &&
              (itemUnitPriceEditable ? (
                <FormControl.Money
                  value={itemUnitPrice}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onChange={onChange && ((v) => onChange("unit_price", v || { value: 0, currency: defaultCurrency }))}
                  defaultCurrency={defaultCurrency}
                  required
                />
              ) : (
                <span
                  styleName={
                    itemUnitPriceLabel ? "item-unitPrice-span--with-label" : "item-unitPrice-span--without-label"
                  }
                >
                  {itemUnitPrice && st.formatMoney(itemUnitPrice)}
                  {itemUnitPriceLabel && <div styleName="item-unitPrice-label">{itemUnitPriceLabel}</div>}
                </span>
              ))}
          </div>

          <div styleName="item-totalPrice" hidden={!itemTotalPrice}>
            {itemTotalPrice && st.formatMoney(itemTotalPrice)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderItemsForm/OrderBillItem.jsx